var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27539 1.2824C7.74152 1.10118 8.25848 1.10118 8.72461 1.2824L13.0137 2.95036C13.6082 3.1816 13.9999 3.75386 14 4.39177V5.96111C13.9998 9.39123 12.1777 12.5628 9.21484 14.2912C8.46409 14.7291 7.53591 14.7291 6.78516 14.2912C3.82231 12.5628 2.00015 9.39123 2 5.96111V4.39177C2.00007 3.75386 2.39179 3.1816 2.98633 2.95036L7.27539 1.2824ZM10.6348 6.08025C10.4027 5.86774 10.0428 5.88351 9.83008 6.1154L7.46582 8.69353L6.13672 7.46599C5.90543 7.25259 5.54456 7.26703 5.33105 7.49822C5.11764 7.72951 5.13208 8.09037 5.36328 8.30388L7.11328 9.91912C7.22454 10.0218 7.37217 10.0757 7.52344 10.0695C7.67482 10.0632 7.81754 9.99662 7.91992 9.88494L10.6699 6.88494C10.8825 6.65287 10.8668 6.29291 10.6348 6.08025Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceVerified);
export default __webpack_public_path__ + "static/media/insurance-verified.0877aba7336c7392bcdeedd2159329e8.svg";
export { ForwardRef as ReactComponent };